import { padPlanArrays } from '../normalizeMarketingPlan';

function stripThousandsSeparators(text) {
  let current = String(text || '').replace(/\$/g, '');
  let previous = '';
  while (current !== previous) {
    previous = current;
    current = current.replace(/(\d),(\d{3})\b/g, '$1$2');
  }
  return current;
}

function splitMarketingSpendTokens(raw) {
  const text = String(raw || '').trim();
  if (!text) {
    return [];
  }
  if (/[\t\r\n]/.test(text)) {
    return text
      .split(/[\t\r\n]+/)
      .map((token) => stripThousandsSeparators(token).trim())
      .filter(Boolean);
  }
  return stripThousandsSeparators(text)
    .split(/[,\s]+/)
    .map((token) => token.trim())
    .filter(Boolean);
}

function parseMarketingSpendToken(token) {
  const cleaned = String(token ?? '').replace(/[$,]/g, '').trim();
  if (cleaned === '' || !/^-?\d+(\.\d+)?$/.test(cleaned)) {
    return null;
  }
  const num = Number(cleaned);
  if (!Number.isFinite(num)) {
    return null;
  }
  return Math.max(0, Math.round(num));
}

export function parseMarketingSpendPaste(raw) {
  return splitMarketingSpendTokens(raw)
    .map(parseMarketingSpendToken)
    .filter((value) => value != null);
}

function syncManualDrawForSpend(state, index, spend) {
  const fundingPct = [...(state.fundingPct || [])];
  const planDrawAmount = [...(state.planDrawAmount ?? [])];
  while (planDrawAmount.length <= index) {
    planDrawAmount.push(null);
  }
  const pct = Number(fundingPct[index]) || 0;
  planDrawAmount[index] =
    spend > 0 && pct > 0 ? Math.min(Math.round((spend * pct) / 100), spend) : null;
  return { ...state, fundingPct, planDrawAmount };
}

export function applyPastedMarketingSpend(state, values, startIndex = 0) {
  if (!Array.isArray(values) || values.length === 0) {
    return state;
  }
  const start = Math.max(0, Math.floor(Number(startIndex) || 0));
  const neededLength = start + values.length;
  const currentLength = state?.marketing?.length ?? 0;
  let next =
    neededLength > currentLength
      ? padPlanArrays(state, neededLength)
      : {
          ...state,
          marketing: [...(state.marketing || [])],
        };

  values.forEach((rawValue, offset) => {
    const index = start + offset;
    if (index >= next.marketing.length) {
      return;
    }
    const spend = Math.max(0, Number(rawValue) || 0);
    next.marketing[index] = spend;
    if (next.marketingPlanManualMode) {
      next = syncManualDrawForSpend(next, index, spend);
    }
  });

  return next;
}
